import { render, staticRenderFns } from "./BulkSendTab.vue?vue&type=template&id=64f94b80&"
import script from "./BulkSendTab.vue?vue&type=script&lang=js&"
export * from "./BulkSendTab.vue?vue&type=script&lang=js&"
import style0 from "./BulkSendTab.vue?vue&type=style&index=0&id=64f94b80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports